<template>
  <article>
    <div :class="{'display1':flex,'display2':none}">
      <!-- <div style="display: flex;justify-content: space-around;"> -->
      账号:<Input v-model="name" style="width: 100px" />
      密码:<Input v-model="password" style="width: 100px" />
      <Button size="small" type="primary" style="background: #2B85E4;" @click="submit()">提交</Button>
    </div>

    <Row :gutter="32" v-if="orderData!=null">
      <Col span="12" class="demo-tabs-style1" style="background: #e3e8ee;width: 100%;">
      <Tabs type="card">
        <TabPane label="订单信息" style="margin-top: -20px;">
          <Scroll height="530">
            <div class="srcoll_content">
              <div>订单号 ：{{orderData.OrderNum}}</div>
              <div>胤之旅单号 ：{{orderData.ApiOrderNum}}</div>
              <div>创建时间 ：{{orderData.CreateDate}}</div>
              <div>联系人 ：{{orderData.Contact}}</div>
              <div>电话:{{orderData.Mobile}}</div>
              <div>出发航班 ：{{orderData.DepFlightNo}}</div>
              <div>出发航班 ：{{orderData.FlightType}}</div>
              <div>出发城市 ：{{orderData.DesCity}}</div>
              <div>到达城市 ：{{orderData.OriCity}}</div>
              <div>出发时间 ：{{orderData.DepDate}}</div>
              <div>返程时间 ：{{orderData.BackDate}}</div>
              <div>返程航班 ：{{orderData.BackFlightNo}}</div>
              <div>手续费 ：{{orderData.TotalCharge}}</div>
              <div>订单金额 ：{{orderData.TotalAmount}}</div>
              <div>成本 ：{{orderData.TotalPay}}</div>
              <div>订单状态 ：{{OrderStateText[orderData.OrderState]}}</div>
              <div>舱位 ：{{orderData.CabinRank}}</div>
              <div>乘客人数 ：{{orderData.PsgCount}}</div>
              <div>订单备注 ：{{orderData.Remark}}</div>
            </div>
          </Scroll>
        </TabPane>
        <TabPane label="乘客信息" style="margin-top: -20px;">
          <Scroll height="530">
            <Table style="margin-top: -10px;" width="1000" height="515" border stripe :columns="columns1" :data="data1"></Table>
          </Scroll>
        </TabPane>
        <TabPane label="编码code信息" style="margin-top: -20px;">
          <Scroll height="530">
            <Input class="input" v-model="textareaValue1" type="textarea" :autosize="{minRows: 2,maxRows:9999999999999}" />
            <div class="inputBtn">
              <Button size="small" type="primary" @click="createPnrCode()" v-if="orderData!=null && orderData.FlightOrderList_Passengers[0].PnrCode==''">创建PnrCode</Button>
              <Button size="small" type="primary" @click="autoFillPrice()" v-if="orderData!=null && orderData.OrderState==1">自动填补价格</Button>
              <Button size="small" type="primary" @click="autoETDZ()" v-if="orderData!=null && orderData.OrderState==1">自动ETDZ</Button>
              <Button size="small" type="primary" @click="PayFlightOrder(orderData.OrderNum)" v-if="orderData!=null && orderData.OrderState==1">调用胤之旅支付</Button>
              <Button size="small" type="primary" @click="OrderRefund(orderData.OrderNum)" v-if="orderData!=null && orderData.OrderState==1">无出票订单退款</Button>
            </div>
            <Input class="input" v-model="textareaValue2" type="textarea" :autosize="{minRows: 2,maxRows:9999999999999}" />
          </Scroll>
        </TabPane>
      </Tabs>
      </Col>
    </Row>
  </article>
</template>

<script>
  import flightApi from '../request/flightApi';
  import userApi from '../request/userApi';

  export default {
    name: 'FlightOrderDetail',
    data() {
      return {
        columns1: [{
            title: '姓名',
            key: 'PsgName',
            fixed: 'left'
          },
          {
            title: '证件号码',
            key: 'CardNO'
          },
          {
            title: '电话',
            key: 'Mobile'
          },
          {
            title: 'Pnr码',
            key: 'PnrCode'
          },
          {
            title: '票号',
            key: 'TicketNumber'
          },
        ],
        OrderStateText: ['未支付', '已支付，等待出票', '已出票', '申请退票', '已退票'],
        data1: [],
        token:'',
        flex: true,
        none: false,
        orderNumber: '',
        name: '',
        password: '',
        orderData: null,
        textareaValue1: '',
        textareaValue2: '',
      };
    },
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;');
      if (this.$route.params.orderNumber && this.$route.params.orderNumber.length) {
        this.orderNumber = this.$route.params.orderNumber;
      }
    },
    methods: {
      submit() {
        userApi.getToken(this.name, this.password).then(TokenRes => {
          console.log(TokenRes)
          if (TokenRes.success == true && TokenRes.data != null) {
            this.token = TokenRes.data.Token;
            this.flex = false;
            this.none = true;
            this.getflightorder(this.orderNumber, TokenRes.data.Token);
            this.getFlightcode(this.orderNumber, TokenRes.data.Token);
          } else {
            this.$Message.error(TokenRes.message);
          }
        })
      },
      getflightorder(orderNumber, token) {
        flightApi.getflightorderinfo(orderNumber, token).then(OrderRes => {
          if (OrderRes.success == true && OrderRes.data != null) {
            OrderRes.data.CreateDate = OrderRes.data.CreateDate.replace("T", " ")
            OrderRes.data.DepDate = OrderRes.data.DepDate.replace("T", " ")
            if (OrderRes.data.BackDate != null) {
              OrderRes.data.BackDate = OrderRes.data.BackDate.replace("T", " ")
            }

            if (OrderRes.data.FlightType == 1) {
              OrderRes.data.FlightType = "单程"
            } else if (OrderRes.data.FlightType == 2) {
              OrderRes.data.FlightType = "往返"
            }

            if (OrderRes.data.CabinRank == 0) {
              OrderRes.data.CabinRank = "不限"
            } else if (OrderRes.data.CabinRank == 1) {
              OrderRes.data.CabinRank = "头等舱"
            } else if (OrderRes.data.CabinRank == 2) {
              OrderRes.data.CabinRank = "公务舱"
            } else if (OrderRes.data.CabinRank == 3) {
              OrderRes.data.CabinRank = "经济舱"
            }

            this.orderData = OrderRes.data;
            this.data1 = OrderRes.data.FlightOrderList_Passengers
          } else {
            this.$Message.error(TokenRes.message);
          }
        })
      },
      getFlightcode(orderNumber, token) {
        flightApi.getFlightcode(orderNumber, token).then(CodeRes => {
          if (CodeRes.success == true && CodeRes.data != null) {
            this.textareaValue1 = CodeRes.data
          } else {
            this.$Message.error(CodeRes.message);
          }
        })
      },
      createPnrCode() {
        flightApi.AutoCreatePnrCode(this.orderNumber).then(res => {
          console.log(res)
          if (res.success == true && res.data != null) {
            this.textareaValue2 += JSON.stringify(res.data)
            this.$Message.success(res.message);
          } else {
            this.$Message.error(res.message);
          }
        })
      },
      autoFillPrice() {
        flightApi.AutoPatPrice(this.orderNumber).then(res => {
          console.log(res)
          if (res.success == true && res.data != null) {
            this.textareaValue2 += JSON.stringify(res.data)
            this.$Message.success(res.data+' '+res.message);
          } else {
            this.$Message.error(res.message);
          }
        })
      },
      autoETDZ() {
        flightApi.AutoETDZ(this.orderNumber).then(res => {
          console.log(res)
          if (res.success == true && res.data != null) {
            this.textareaValue2 += JSON.stringify(res.data)
            this.$Message.success(res.data+' '+res.message);
          } else {
            this.$Message.error(res.message);
          }
        })
      },
      PayFlightOrder(OrderNum){
        flightApi.PayFlightOrder(OrderNum).then(sucRes=>{
          if(sucRes.success){
            this.$Message.success(sucRes.message);
          }else{
            this.$Message.error(sucRes.message);
          }
        });
	  },
      OrderRefund(OrderNum){
        flightApi.refundNoTicketFlightOrder(OrderNum,this.token).then(sucRes=>{
          if(sucRes.success){
            this.$Message.success(sucRes.message);
          }else{
            this.$Message.error(sucRes.message);
          }
        });
      },
    }
  };
</script>

<style scoped lang="less">
  .demo-tabs-style1>.ivu-tabs-card>.ivu-tabs-content {
    height: 120px;
    margin-top: -16px;
  }

  .demo-tabs-style1>.ivu-tabs-card>.ivu-tabs-content>.ivu-tabs-tabpane {
    background: #fff;
  }

  .demo-tabs-style1>.ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab {
    border-color: transparent;
  }

  .demo-tabs-style1>.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active {
    border-color: #fff;
  }

  .srcoll_content {
    width: 98%;
    margin: -2% 5% 0 5%;
  }

  .display1 {
    display: flex;
    justify-content: space-around;
    padding-top: 5px;
    margin-bottom: 10px;
  }

  .display2 {
    display: none;
  }
  .input{
    margin:10px 2% 20px;
    width:96%;
    border:1px solid #2B85E4;
    border-radius: 5px;
  }
  .inputBtn{
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .inputBtn Button{
    background: #2B85E4;
    margin:15px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/FlightOrderDetail.vue